var GAME_CACHE_TAGS = {
  GET_GAME_ROOMS: 'GetGameRooms',
  GET_FAVE_GAMES: 'GetFavGames'
};
GAME_CACHE_TAGS.gamesTagsArray = Object.values(GAME_CACHE_TAGS);
export { GAME_CACHE_TAGS };